module.exports = __webpack_public_path__ + "static/media/about-us.d79bef7d.jpg";